<template>
  <div>
    <select class="form-control" @change="onChanged($event)">
      <option value="0" :selected="selectedVal == ''"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.STUDENTSTATUS"
        :selected="selectedVal == item.STUDENTSTATUS"
      >
        {{ item.STUDENTSTATUSNAME }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();

export default {
  name: "StudentStatus",
  props: {
    onChanged: Function,
    selectedVal: Number
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      this.items = await masterDataProvider.getStudentStatus({
        token: this.token,
        lang: this.currentLang
      });
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
